import { DateTime, Duration, DurationLike } from 'luxon';

const defaultLocale = 'pt-BR';
const defaultZone = 'America/Sao_Paulo';

export function toDateTime(isoDate: string | Date, options?: { zone?: string }): DateTime {
    const zone = options?.zone ?? defaultZone;
    return DateTime.fromISO(isoDate instanceof Date ? isoDate.toISOString() : isoDate, {
        zone,
        locale: defaultLocale,
    });
}

export function formatDateTime(isoDate: string | Date, format: string = "yyyy-MM-dd", options?: { zone?: string }): string {
    return toDateTime(isoDate, options).toFormat(format);
}

export function diffInDays(fromDate: DateTime | Date | string, toDate: DateTime | Date | string, options?: { zone?: string }): number {
    fromDate = fromDate instanceof DateTime ? fromDate : toDateTime(fromDate, options);
    toDate = toDate instanceof DateTime ? toDate : toDateTime(toDate, options);

    const diff = toDate.diff(fromDate, 'days').days;

    return Math.round(diff);
}

export function durationToHuman(duration: Duration): string {
    const days = duration.days;
    const hours = duration.hours;
    const minutes = duration.minutes;

    return [
        days ? `${days} dia${days > 1 ? 's' : ''}` : '',
        hours ? `${hours}h` : '',
        minutes ? `${minutes}min` : ''
    ].filter(Boolean).join(' ');
}

export function verifyDateBetween(
    date: string | Date,
    start: string | Date,
    end: string | Date,
    options?: { zone?: string }
): boolean {
    const dateTime = toDateTime(date, options);
    const startDateTime = toDateTime(start, options);
    const endDateTime = toDateTime(end, options);

    return dateTime >= startDateTime && dateTime <= endDateTime;
}

export function verifyDateMajorThan(
    dateTime: DateTime | Date,
    startDateTime: DateTime | Date,
    options?: { zone?: string }
): boolean {
    dateTime = dateTime instanceof DateTime ? dateTime : toDateTime(dateTime);
    startDateTime = startDateTime instanceof DateTime ? startDateTime : toDateTime(startDateTime);
    return dateTime.toMillis() < startDateTime.toMillis();
}

export function addOrSubtractDays(date: DateTime | Date, durationLike: DurationLike, options?: { zone?: string }): DateTime {
    const dateTime = toDateTime((date instanceof DateTime ? date.toFormat("yyyy-MM-dd") : date.toISOString()) , options);
    return dateTime.plus(durationLike);
}

export function sameDate(
    date1: DateTime | Date | string,
    date2: DateTime | Date | string,
    options?: { zone?: string }
): boolean {
    const dateTime1 = date1 instanceof DateTime ? date1 : toDateTime(date1)
    const dateTime2 = date2 instanceof DateTime ? date2 : toDateTime(date2)

    return dateTime1.hasSame(dateTime2, 'day');
}